import {svgjs} from 'svg.js';
import {Init} from 'core/Init';
import {Attachable} from 'core/items/base/Attachable';

import {APP_EVT, APP_ROLE, SERIES_NAMES, SERIES_ID} from 'core/config/constants';
import {Debug} from 'core/util/Debug';
import {DataBase} from 'core/services/DataBase';

declare var SVG: svgjs.Library;


class DataOffice extends DataBase {

    protected modal: string = '';
    protected msg: string = '';

    /**
     *
     *
     */
    constructor() {

        super();

        // this is required so that the showFenceHitpoints function knows who "this"
        // is. Cannot use lambda functions for overriding in class inheritance
        // therefore must use prototype functions and bind "this" beforehand.
        this.showSaveModal = this.showSaveModal.bind(this);

        Init.emitter.on(APP_EVT.SAVE_LIBRARY_DESIGN, this.initSaveDesign);
        Init.emitter.on(APP_EVT.SHOW_SAVE_MODAL, this.showSaveModal);
        Init.emitter.on(APP_EVT.SAVE_CHECK, this.saveCheck);
        Init.emitter.on(APP_EVT.SAVE_DESIGN, this.initSaveDesign);
        Init.emitter.on(APP_EVT.SHOW_LIBRARY_OPENER, this.showLibrarySearchModal);
        Init.emitter.on(APP_EVT.SHOW_SHARE_3D_MODAL, this.showShare3dModal);
        Init.emitter.on(APP_EVT.SHARE_3D_SUCCESS, this.closeShare3dModal);

        Init.emitter.on(APP_EVT.SHOW_RETRIEVE_MODAL, this.showRetrieveModal);
        Init.emitter.on(APP_EVT.SHOW_RETRIEVE_MODAL, this.showRetrieveModal);
        Init.emitter.on(APP_EVT.RETRIEVE_USER_DESIGN, this.retrieveUserDesign);
        Init.emitter.on(APP_EVT.RETRIEVE_LIBRARY_CODES, this.retrieveLibraryCodeList);
        Init.emitter.on(APP_EVT.LIBRARY_CODE_LIST_SUCCESS, this.librarySearchSuccess);


        this.modal = '';
        this.msg = '';

    }


    /**
     *
     */
    showSaveModal(): void {

        if (Init.getAppAlertStatus() !== false) {

            $('#modal-blank #msg').html(Init.getAppAlertMessage());
            $('#modal-blank').modal('toggle');

            return;

        }

        if (Init.app_role != APP_ROLE.LIBRARY) {

            this.modal = '#modal-save';
            this.msg = 'Enter a name for your design.';

        } else {

            this.modal = '#modal-library-save';
            this.msg = '';
            $(this.modal + ' #user_name').val(localStorage.getItem('user_name'));
        }

        let alert: string[] = this.findOrphanItems();

        if (alert.length > 0) {
            let msg: string = 'The following unattached items need to be removed from your design before saving:';
            for (let i of alert) {
                msg += '<li>' + i + '</li>';
            }

            $('#modal-blank #msg').html(msg);
            $('#modal-blank').modal('toggle');
            return;
        }

        // do not allow small-structure sets to be saved
        switch (Init.series_id) {
            case SERIES_ID.CLASSIC:
            case SERIES_ID.ARCHITECTURAL:
            case SERIES_ID.RUSTIC:
                let too_small: boolean = Init.line.rules.designTooSmall();
                //console.log(too_small);
                if (too_small === true) {
                    let msg: string = 'Small and Medium Structures require a Swing Beam, Bridge, or Monkey Bars for stability. Add one of these accessories or start over with a larger Structure.';
                    $('#modal-blank #msg').html(msg);
                    $('#modal-blank').modal('toggle');
                    return;
                }
                break;
        }

        Init.emitter.emit(APP_EVT.HIDE_OPTION_STATES);

        $(this.modal).modal('toggle');

        $(this.modal + ' .msg-alert').html('');


        $(this.modal + ' .msg').html(this.msg);
        $(this.modal + ' #save').show();
        $(this.modal + ' #save-over').hide();

        if (Init.design_name != '') {
            $(this.modal + ' #save-design-name').val(Init.design_name);
        }
        $(this.modal + ' #save-design-name').trigger('focus');

        Init.emitter.on(APP_EVT.KEY_DOWN_ENTER, this.saveCheck);

    };


    /**
     *
     */
    showLibrarySearchModal = (): void => {

        $('#btn-retrieve-library-design').prop('disabled', true);
        $('#retrieve-library-filter').val('');


        $('#modal-library-search').modal('show').on('shown.bs.modal', function() {
            $('#retrieve-library-filter').trigger('focus');
        });

        let _that = this;

        $('#modal-library-search #library-list').on('click', '.design-list-row', function (this) {

            let design_id: string = $(this).data('id');
            let source: string = 'library';

            Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, design_id, source);

            _that.closeLibrarySearchModal();

        });

        $('#modal-library-search #btn-retrieve-library-design').on('click', function (this) {

            let design_id: string = $(this).data('id');
            let source: string = 'library';

            Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, design_id, source);

            _that.closeLibrarySearchModal();

        });

        $('#modal-library-search #retrieve-library-filter').on('input', function (this) {

            let input: any = $(this).val();
            input = input.replace(/\D/g, '');

            $(this).val(input);

            Init.emitter.emit(APP_EVT.RETRIEVE_LIBRARY_CODES, input);

        });

    }


    /**
     *
     */
    showShare3dModal = (): void => {

        //console.log('showRetrieveModal');
        let modal: string = '#modal-share-3d';

        $(modal).modal('show');

        $(modal + ' #btn-share-3d-link').on('click', function (this) {

            $(modal + ' .msg').html('').removeClass('alert-text');

            let email_address: any = $(modal + ' #email-address').val();
            let _that = this;

            if (email_address == '' || email_address == undefined) {

                $(modal + ' #email-address').trigger('focus');
                $(modal + ' .msg').html('Please enter an email address.').addClass('alert-text');
                return;

            } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_address) === false) {

                $(modal + ' #email-address').trigger('focus');
                $(modal + ' .msg').html('Invalid email address.').addClass('alert-text');
                return;

            } else {

                //console.log(filter);
                let data: any = {};

                data.design_name = Init.design_name;
                data.design_id = Init.design_id;
                data.series_id = Init.series_id;
                data.email_address = email_address;
                //data.designed_by = $('#retrieve-user-email').val();

                $.ajax({
                    type: 'POST',
                    url: '/data/share3d',
                    dataType: 'json',
                    data: data
                })
                    .done(function (data) {
                        Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
                    })
                    .fail(function (data) {
                        Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
                    })
                    .always(function (data) {
                        Init.emitter.emit(APP_EVT.SHARE_3D_SUCCESS, data);
                    });
            }
        });
        // Init.emitter.on(APP_EVT.KEY_DOWN_ENTER, this.emailShare3d);
        //_that.closeShare3dModal();
    }


    /**
     *
     */
    closeShare3dModal = (): void => {

        let modal: string = '#modal-share-3d';
        $(modal).modal('hide');

    }


    /**
     *
     * @param data
     */
    librarySearchSuccess = (data): void => {

        $('#btn-retrieve-library-design').prop('disabled', true);

        let modal: string = '#modal-library-search';
        let status: string;

        let series_name: string = SERIES_NAMES[Init.series_id];

        let str = `<table class="table table-hover table-sm">
        <thead><tr>
        <th>library id</th>
        </tr></head>`;

        //console.log(data.length);

        if (data.length) {

            for (let i of data) {

                str += `<tr class="design-list-row" data-id="${i.id}"><td>${series_name} ${i.library_id}</td></tr>`;

            }

            if (data.length == 1) {
                $('#btn-retrieve-library-design').prop('disabled', false);
                $('#btn-retrieve-library-design').data('id', data[0].id);
            }

        } else {

            str += '<tr class="design-list-row"><td colspan="3">no designs found</td></tr>';

        }
        str += '</table>';

        $(modal + ' #library-list').html(str);

    };

    /**
     *
     */
    retrieveLibraryCodeList = (filter: string): void => {

        //console.log(filter);
        let data: any = {};

        data.filter = filter;
        data.series_id = Init.series_id;
        //data.designed_by = $('#retrieve-user-email').val();

        $.ajax({
            type: 'POST',
            url: '/data/libraryCodeList',
            dataType: 'json',
            data: data
        })
            .done(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            })
            .always(function (data) {
                Init.emitter.emit(APP_EVT.LIBRARY_CODE_LIST_SUCCESS, data);
            });

    };


    /**
     *
     */
    closeLibrarySearchModal = (): void => {

        $('#modal-library-search').modal('hide');
        $('#btn-retrieve-library-list').off('click');
        $('#library-list').off('click');

    }

    /**
     * see if we have a design already saved under this name
     *
     */
    saveCheck = (): void => {

        //console.log('saveCheck');

        Debug.clear();

        let modal: string;
        let saveUrl: string;

        if (Init.app_role == APP_ROLE.LIBRARY) {
            modal = '#modal-library-save';
            saveUrl = '/data/saveLibraryCheck';
        } else {
            modal = '#modal-save';
            saveUrl = '/data/saveCheck';
        }

        $(modal + ' .msg-alert').html('');

        let data: any = {};
        let item_list: Map<string, Attachable> = Init.set_design.items;

        if (item_list.size == 0) {

            $(modal + '  .msg-alert').html(this.createAlert('There are no items in this design. Please create a design before saving it.'));
            return;

        }

        let design_name: any = $(modal + '  #save-design-name').val();

        if (design_name == '' || design_name == undefined) {

            $(modal + '  #save-design-name').trigger('focus');
            $(modal + '  .msg-alert').html(this.createAlert('Please enter a design name.'));
            return;

        }

        Init.set_design.setDesignName(data.design_name);

        let _that = this;

        data.designName = design_name;

        $.ajax({
            type: 'POST',
            url: saveUrl,
            dataType: 'json',
            data: data
        })
            .done(function (data) {

                if (data.status == 'valid') {

                    _that.initSaveDesign();

                } else if (data.status == 'overwrite') {

                    $(modal + '  .msg-alert').html(_that.createAlert('Save over existing design?'));
                    $(modal + '  #save').hide();
                    $(modal + '  #save-over').show();
                    $('#btn-save-over-yes').trigger('focus');
                    Init.emitter.on('keyDownEnter', _that.saveDesign);

                }
            })
            .fail(function (data) {
                Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
            });

    };


    /**
     *
     */
    initSaveDesign = (): void => {

        Init.emitter.off(APP_EVT.KEY_DOWN_ENTER, this.saveDesign);

        let modal: string = (Init.app_role == APP_ROLE.LIBRARY) ? '#modal-library-save' : '#modal-save';

        Debug.clear();
        let item_list: Map<string, Attachable> = Init.set_design.items;

        let design_name: any = $(modal + ' #save-design-name').val();

        if (design_name == '' || design_name == undefined) {

            $(modal + ' #save-design-name').trigger('focus');
            $(modal + ' .msg').html('Please enter a design name.');
            return;

        } else if (item_list.size == 0) {

            $(modal + ' #save-design-name').trigger('focus');
            $(modal + ' .msg').html('There are no items in this design.<br>Please create a design before saving it.');
            return;

        }

        let user_name: string;

        this.saveDesign(design_name, user_name);

    };


    /**
     *
     */
    showRetrieveModal = (): void => {

        if (Init.app_role == APP_ROLE.LIBRARY) {

            let modal: string = '#modal-library-list';

            $(modal).modal('toggle');

            //this.retrieveLibraryList('');

        } else {

            //console.log('showRetrieveModal');
            let modal: string = '#modal-retrieve';

            $(modal).modal('show');

            //let design_name: string = localStorage.getItem('design_name');
            let design_name: string = Init.getStorage('design_name');

            $(modal + ' .msg').html('Enter the name of the design you want to open.');
            $(modal + ' #retrieve-design-name').val(design_name);
            $(modal + ' #retrieve-design-name').trigger('focus');

            Init.emitter.on(APP_EVT.KEY_DOWN_ENTER, this.retrieveUserDesign);
        }
    };


    /**
     *
     */
    retrieveUserDesign = (): void => {

        let modal: string = '#modal-retrieve';

        Init.emitter.off(APP_EVT.KEY_DOWN_ENTER, this.retrieveUserDesign);

        let designName: any = $(modal + ' #retrieve-design-name').val();

        if (designName == '' || designName == undefined) {

            $(modal + ' #modal-retrieve #retrieve-design-name').trigger('focus');
            $(modal + ' #modal-retrieve .msg').html('Please enter a design name.');
            return;
        }

        this.retrieveDesign(designName);

    };


    /** **************************************************************
     *                                   GETTERS - SETTERS
     */

}

export {DataOffice};

